import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_99: FaireProductEntity = {
  token: "legacy_prod_abbott-99",
  type: "product",
  name: 'Large Sheep on Legs Planter 3" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2f1dc96363dd3c504e2110ccae16b4f8d30e1f39f8e02642277cd42ffd9b948f.jpeg",
  priceDollars: 22,
  isBestseller: true,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
